// Normalizes any shape an id-list value can arrive in into a flat list of unique
// integer ids. Upstream sources are inconsistent: a multi-value field loaded fresh
// yields number[], StringId variants yield string[], a single-value code path wrapping
// an already-array value yields a nested array, and cached/XML round-trips yield a
// comma-joined string ("33,32,30"). All of these must resolve to [33, 32, 30] before
// being used to build an items $filter (one "(Id eq n)" clause per id) — anything
// else produces invalid OData like "(Id eq 33,32,30)".
//
// String entries must be strictly integral: bare parseInt would turn garbage like
// "2026-07-23" into 2026 and silently resolve the wrong item, which is worse than
// resolving nothing. Non-integral entries are dropped instead.

const strictIntegerPattern = /^-?\d+$/;

const parseStrictInteger = (entry: string): number => {
    const trimmed = entry.trim();
    return strictIntegerPattern.test(trimmed) ? parseInt(trimmed, 10) : NaN;
};

export const normalizeUserIdList = (value: any): number[] => {
    if (value === null || value === undefined || value === "") {
        return [];
    }

    const flattened: any[] = (Array.isArray(value) ? value : [value]).flat(Infinity);

    const ids: number[] = flattened
        .flatMap(entry => typeof entry === "string" ? entry.split(",") : [entry])
        .map(entry => typeof entry === "string" ? parseStrictInteger(entry) : entry)
        .filter(id => Number.isInteger(id));

    return Array.from(new Set(ids));
}
